import React from 'react';
import { Marker } from 'react-map-gl/maplibre';
import { MapPin } from 'lucide-react';

/** The temporary pin dropped by Map tab > Reference > Find address; a second search replaces it. */
export default function FoundPlaceMarker({ pin }) {
  if (!pin) return null;
  return (
    <Marker longitude={pin.lon} latitude={pin.lat} anchor="bottom">
      <div data-testid="found-place-pin" title={pin.label}>
        <MapPin size={28} color="#f87171" fill="#f87171" fillOpacity={0.35} />
      </div>
    </Marker>
  );
}
